import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  style: {"padding":"10px 0"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.reverseWords != null && _ctx.reverseWords.length > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("button", {
          class: "profile__run",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.exportHandle && _ctx.exportHandle(...args)))
        }, _toDisplayString(_ctx.Ti18N("exportWords")), 1)
      ]))
    : _createCommentVNode("", true)
}